/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import SystemStatusService from 'cio/services/system-status';
import { task } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';

export default class StatusLabel extends Component {
  @service systemStatus!: SystemStatusService;

  @tracked status = '';

  statusCheck = task({ drop: true }, async () => {
    this.systemStatus.fetchSystemStatus
      .perform()
      .then((data) => {
        // the indicator will come back with 'none', 'minor', 'major', or 'critical' as the value
        // we only care if it is 'none' which means no issues or not to update the label
        this.status = data.status.indicator !== 'none' ? 'Outages' : 'All okay';
      })
      .catch(() => {
        this.status = '';
      });
  });

  get labelColor() {
    return this.status === 'Outages' ? 'is-error' : 'is-success';
  }

  get showLabel() {
    return !this.statusCheck.isRunning && this.status !== '';
  }

  constructor(owner: unknown, args: any) {
    super(owner, args);
    this.statusCheck.perform();
  }
}
